import { NgClass } from '@angular/common';
import {
  Component,
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  QueryList,
  ViewChild,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@Directive({
  selector: '[qtDialogTitle]',
  host: { class: 'qt-dialog-title' },
  standalone: true,
})
export class DialogTitleDirective {}

@Directive({
  selector: '[qtDialogContent]',
  // host: { class: 'qt-dialog-content' },
  standalone: true,
})
export class DialogContentDirective {
  el = inject(ElementRef);
}

@Directive({
  selector: '[qtDialogActions]',
  host: { class: 'qt-dialog-actions' },
  standalone: true,
})
export class DialogActionsDirective {}

/**
 * Wrapper for full screen dialog
 *
 * @export
 * @class DialogComponent
 */
@Component({
  selector: 'qt-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatDialogModule,
    NgClass,
    FlexLayoutModule,
    MatButtonModule,
  ],
})
export class DialogComponent {
  @Input() disableClose = false;
  @Input() color: 'primary' | 'accent' | 'warn' | null = 'primary';
  @Input() contentClass = '';

  @ContentChildren(DialogTitleDirective)
  dialogTitle: QueryList<DialogTitleDirective>;
  @ContentChildren(DialogContentDirective)
  dialogContent: QueryList<DialogContentDirective>;
  @ContentChildren(DialogActionsDirective)
  dialogActions: QueryList<DialogActionsDirective>;
  @ViewChild('contentDiv') contentDiv: ElementRef;
}
